<template>
  <popup @close-popup="closePopup">
    <template v-slot:content>
      <div class="exceed-limit">
        <div class="exceed-limit__icon">
          <img src="../../assets/icons/Warning.svg" alt="info" />
        </div>
        <h3 class="title title--center">Basket size exceeds limit!</h3>
        <p class="exceed-limit__message">
          We noticed you are trying to purchase an item worth more than your spending limit. We would need to have you link an account by
          providing a bank statement to remove limits on your account and successfully complete your purchase.
        </p>
        <div class="exceed-limit__ctas">
          <div class="btn btn__primary btn--lg">
            <a :href="customerPortal" target="_blank">Link bank account</a>
          </div>
          <div class="btn btn__secondary btn--lg">
            <button @click="closePopup">Reduce basket size</button>
          </div>
        </div>
      </div>
    </template>
  </popup>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

import Popup from '@/components/cards/popup/index.vue'
import store from '@/composables/useZeroWidgetStore/methods'

const emit = defineEmits<{
  (e: 'close-popup'): void
}>()
const closePopup = () => {
  return emit('close-popup')
}

const customerPortal = computed(() => store.state.customerPortaAddress)
</script>
